/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskGetJobsPathParameters } from 'api/actions/helpdesk-get-jobs/helpdesk-get-jobs-path-parameters';
import { HelpdeskGetJobsResponse } from 'api/actions/helpdesk-get-jobs/helpdesk-get-jobs-response';

type HelpdeskGetJobsQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskGetJobs action.
 */
export const helpdeskGetJobsActionPath = new SweetPath<keyof HelpdeskGetJobsPathParameters>('/help-desk/jobs/', {
  path: '{param}',
});

/**
 * Creates a contextualized HelpdeskGetJobs actions.
 */
export default function createHelpdeskGetJobsAction(axios: AxiosInstance) {
  return function helpdeskGetJobsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HelpdeskGetJobsQueryParameters } = {}) {
    const path = helpdeskGetJobsActionPath.original;

    return axios.get<HelpdeskGetJobsResponse, HelpdeskGetJobsResponse>(path, { params: query, headers });
  };
}
